import { IFRAME_MESSAGES, WidgetSelectorAttributes } from "../lib/constants";
import { env } from "../lib/env";

(function () {
  window.onload = function () {
    window.addEventListener("message", function (event) {
      const message = event.data;
      if (message?.type === IFRAME_MESSAGES.launchWidgetFromExternal) {
        const aichatBtnLauncher = document.getElementById(
          "aichat-messenger-launcher",
        ) as HTMLButtonElement;
        if (aichatBtnLauncher) aichatBtnLauncher.click();
        return;
      }
      if (message) {
        const script = document.createElement("script");
        script.type = "module";
        script.src = `${env.widgetUrl}/ai-chat-widget-container.js`;
        script.id = message.id;
        script.setAttribute(
          WidgetSelectorAttributes.orgIdAttribute,
          message.orgId,
        );
        script.setAttribute(
          WidgetSelectorAttributes.apiKeyAttribute,
          message.apiKey,
        );
        script.setAttribute(
          WidgetSelectorAttributes.isPlaygroundAttribute,
          message.isPlayground,
        );
        script.setAttribute(
          WidgetSelectorAttributes.isAlwaysOpenAttribute,
          String(message.isAlwaysOpen),
        );
        if (message.userId) {
          script.setAttribute(
            WidgetSelectorAttributes.userIdAttribute,
            message.userId,
          );
        }
        document.body.appendChild(script);
      }
    });
  };
})();
